export default {
  free_items: '{{count}} points = Free items 🤩',
  button: {
    okay: 'Okay',
  },
};
